import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface MarkdownLinkProps {
  href?: string;
  children?: ReactNode;
}

// The `a` component for ReactMarkdown: an app path becomes a router Link, and
// any other address opens in a new tab without access to its opener.
export default function MarkdownLink({ href, children }: MarkdownLinkProps) {
  if (href && !href.startsWith("http") && !href.startsWith("#")) {
    return <Link to={href}>{children}</Link>;
  }
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
}
